import { ExtractRouteParams } from "@CommonUtils/routes";

export const RouteGetFixturesGuessing_fixturesGuessingId_Logs =
  "/fixtures-guessing/:fixturesGuessingId/logs";

export type ParamsGetFixturesGuessing_fixturesGuessingId_Logs = ExtractRouteParams<
  typeof RouteGetFixturesGuessing_fixturesGuessingId_Logs
>;

export interface ResponseGetFixturesGuessing_fixturesGuessingId_Logs {
  fixturesGuessingId: number;
  requestPath: string | null;
  responsePath: string | null;
  errorDetails: string | null;
}
